export default __webpack_public_path__ + "static/media/hand-light.f1e0539f.svg";